import React, { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';

const TinyMCEEditor = (props) => {
  const editorRef = useRef(null);

  return (
    <>
      {props.enableImageEncode != undefined && props.enableImageEncode ?
        <Editor
          tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
          // apiKey="pjtleur6dzqizbvjc7ehqcfocwvo7bwpp5mtwxzux5y1ctzl"
          onInit={(evt, editor) => editorRef.current = editor}
          value={props.value}
          init={{
            height: 500,
            menubar: true,
            plugins: [
              'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
              'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
              'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount', 'powerpaste'
            ],
            toolbar: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image code',
            powerpaste_allow_local_images: true,
            powerpaste_word_import: 'prompt',
            powerpaste_html_import: 'prompt',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'            
          }}
          onEditorChange={(content) => {
            props.setValue(content)
          }}
        />
        :

        <Editor
          tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
          // apiKey="pjtleur6dzqizbvjc7ehqcfocwvo7bwpp5mtwxzux5y1ctzl"
          onInit={(evt, editor) => editorRef.current = editor}
          value={props.value}
          init={{
            height: 500,
            menubar: true,
            plugins: [
              'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
              'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
              'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount', 'powerpaste'
            ],
            toolbar: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image code',
            powerpaste_allow_local_images: true,
            powerpaste_word_import: 'prompt',
            powerpaste_html_import: 'prompt',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
            images_upload_handler: async blobInfo => {
              return new Promise((resolve, reject) => {
                let imageFile = new FormData();
                imageFile.append("files", blobInfo.blob());
                ApiHelper.post(APIURLConstants.UPLOAD_TMCE_IMAGE_HANDLE, imageFile)
                  .then((res) => {
                    if (res && res.data) {
                      resolve(res.data);
                    }
                  })
                  .catch((err) => {
                    console.log('err', err);
                    reject(err);
                  });
              })
            }
          }}
          onEditorChange={(content) => {
            props.setValue(content)
          }}
        />
      }
    </>
  );
};

export default TinyMCEEditor;
